import type React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';

import { Info } from '@vlabs/monokit/shared/ui/info';

import { useSourceGroupInfoTranslation } from './i18n';
import st from './SourceGroupInfo.module.sass';

function SourceGroupInfo(): React.JSX.Element {
  const { t } = useSourceGroupInfoTranslation();

  return (
    <div className={st.Container}>
      <Info
        icon={<InfoCircleFilledIcon className={st.InfoIcon} />}
        title={t('title')}
      >
        <p className={st.Description}>{t('content')}</p>
      </Info>
    </div>
  );
}

export { SourceGroupInfo };
